import React, { Component } from  'react';
import * as d3 from 'd3';
class RandomFact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      facts: [{
        body: "Hohoho"
      }],
      factIndex: 0
    }
  }

  render() {

    return <span onClick={this.loadRandomFact.bind(this)} style={{cursor: "pointer"}}>
      {this.state.facts[this.state.factIndex].body}
    </span>
  }

  async componentDidMount() {
    const facts = await d3.json("data/facts.json");
    this.setState({facts})
    this.loadRandomFact();
  }

  loadRandomFact() {
    const randomIndex = Math.floor(Math.random() * this.state.facts.length)
    this.setState({factIndex: randomIndex})
  }
}

export default RandomFact;

